import type { ShippingClient, TypedClient } from '@platform/openapi';

export const SETUP_FORM_ID = 'setup-step';

export type StepFlow = {
  readonly formId: string;
  readonly submit: (save: () => Promise<unknown>) => void;
  readonly fail: (message: string) => void;
};

export type StepViewProps = {
  readonly api: TypedClient;
  readonly shipping: ShippingClient;
  readonly flow: StepFlow;
  readonly guideUrl: string | null;
};

export type StepStatus =
  | { readonly kind: 'idle' }
  | { readonly kind: 'saving' }
  | { readonly kind: 'saved' }
  | { readonly kind: 'failed'; readonly message: string };
